// Ambient video assets used throughout the site
export const AMBIENT_VIDEOS = {
  // Landscape — best for wide banners / section backgrounds
  landscape:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/wu0vumad_3121381-hd_1920_1080_25fps.mp4",
  // Portrait — best for narrow side panels and accent cards
  portrait:
    "https://customer-assets.emergentagent.com/job_support-growth-1/artifacts/5hbey2ni_14899575_1080_1920_24fps.mp4",
};

// Posters: shown while videos load / on slow connections / when video is blocked
export const AMBIENT_POSTERS = {
  landscape: "https://images.pexels.com/photos/32510373/pexels-photo-32510373.png", // tranquil forest trail
  portrait: "https://images.pexels.com/photos/28551505/pexels-photo-28551505.jpeg", // sunlit gravel path
};
